import { createContext, ReactNode, useContext } from 'react';

import { SanityClientFetchOptions } from '../data/sanity/types';

// Create a context for the market data
const PreviewContext = createContext<PreviewProviderProps>({});

// Define a custom hook to access the market context
export const usePreviewSettings = (): PreviewProviderProps =>
  useContext(PreviewContext);

// Define a MarketProvider component to wrap your app with
export type PreviewProviderProps = SanityClientFetchOptions;

export const PreviewProvider: React.FC<
  PreviewProviderProps & { children: ReactNode }
> = ({ draftMode, children }) => {
  return (
    <PreviewContext.Provider value={{ draftMode }}>
      {children}
    </PreviewContext.Provider>
  );
};
